import { useCallback, useState } from "react";
import { Expertise } from "../../../models/Expertise";
import ExpertiseRepository from "../../../repositories/ExpertiseRepository";

export const useGetExpertises = () => {
  const [data, setData] = useState<Expertise[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const loadData = useCallback(async (params = {}) => {
    setIsLoading(true);

    await ExpertiseRepository.findAll({
      ...params,
    })
      .then((response) => {
        const { data: responseData } = response.data;
        setData(responseData);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return {
    data,
    isLoading,
    loadData,
  };
};
